import React from 'react'
import { FormControl } from 'react-bootstrap'
import PropTypes from 'prop-types'
import '../fieldGroup.scss'

class InputComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hidden: true,
        };
    }

    toggleShowHide = () => {
        this.setState({ hidden: !this.state.hidden });
    }

    render() {
        const { input, type, formProps, className, readOnly, value } = this.props
        let passwordField = input.name === 'confirmPassword' || input.name === 'password' || input.name === 'currentPassword';
        let searchField = input.name === 'search';
        return <div>
            {passwordField && <div className='pwdContainer'>
                <span className={this.state.hidden ? 'hide-password' : 'show-password'} onClick={this.toggleShowHide} />
                <FormControl
                    {...input}
                    {...formProps}
                    type={this.state.hidden ? 'password' : 'text'}
                    className={className}
                    readOnly={readOnly}
                />
            </div>}
            { !passwordField && <div className={searchField ? 'searchContainer' : ''}>
                { searchField && <span className='searchField' /> }
                <FormControl
                    {...input}
                    {...formProps}
                    type={type}
                    className={className}
                    readOnly={readOnly}
                    onChange={input.onChange}
                    value={value !== undefined ? value : input.value}
                />
            </div>}
        </div>
    }
}

InputComponent.defaultProps = {
    className: '',
    input: {},
    type: 'text',
    formProps: {},
    readOnly: false,
}

InputComponent.propTypes = {
    className: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    type: PropTypes.string,
    formProps: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    value: PropTypes.string,
}

export default InputComponent



// WEBPACK FOOTER //
// ./src/components/core/FieldGroupComponent/FieldComponents/InputComponent.js